import { Content, Connector } from './items.styled';
import { Item } from './item';
import { getItems } from './items.func';

export const Items = (props) => {
  const { event } = props;
  const { data } = event;
  const node = window.config.nodes[event.source];
  const nodeType = node?.rack_type;

  /**
   * get foto items elements
   * @param {*} items
   * @returns
   */
  const getItemsEl = () => {
    const items = getItems(nodeType, data, data.photo_stay, data.vehicle_plate_stay);
    const out = [];
    items.forEach((el, idx) => {
      // directional connector between "entry" and "exit" evidence — makes the
      // въезд → выезд comparison read at a glance (solid chevron, no dashes).
      if (idx > 0) {
        out.push(
          <Connector key={'c' + idx} aria-hidden="true">
            <svg viewBox="0 0 24 24" fill="none">
              <path d="M9 5l7 7-7 7" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
          </Connector>
        );
      }
      // keep a single "Обновить ГРЗ" (run_recognition) control — on the first card only
      out.push(<Item key={idx} item={el} source={event.source} id={event.id} refreshPlateButton={idx !== 0} />);
    });
    return out;
  };

  const itemsEl = getItemsEl();

  return <Content>{itemsEl}</Content>;
};
